import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  unity: {},
  unities: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.unity = {
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, unity) => {
    state.unity = { ...unity }
    state.type = 'edit'
  },

  save: ({ state }, unity) => {
    const id = unity.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/unity/${id || ''}`, unity)
      .then(_ => {
        store.dispatch('unityStore/get')
        showSuccess('Unidade salva com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/unity?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.unities = res.data

        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/unity/${id}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/unity/${id}`)
      .then(_ => {
        store.dispatch('unityStore/get')
        showSuccess('Unidade excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = {
  getById: state => id => {
    return state.unities.data.find((u) => String(u.id) === String(id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
